/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { memo } from 'react';
import { FieldData } from '../../../types';
import { RecommendationInspector } from './RecommendationInspector';
import { RecommendationComparator } from './RecommendationComparator';
import { Modal } from '@tcc/crate';
import classNames from 'classnames';

interface CurveModalProps {
  field: FieldData & { _id: string; _index: number };
  onClose: () => void;
  fieldIndex: number;
  multipleHybrids?: boolean;
}

export const CurveModal = memo(function CurveModal({ onClose, field, fieldIndex, multipleHybrids }: CurveModalProps) {
  const className = classNames('recommendation-curve-modal', { 'seed-recommendation': multipleHybrids });
  return(
    <Modal
      show
      onClose={onClose}
      size="XL"
      className={className}
    >
      {multipleHybrids ? (
        <RecommendationComparator onClose={onClose} field={field} fieldIndex={fieldIndex} />
      ) : (
        <RecommendationInspector onClose={onClose} field={field} fieldIndex={fieldIndex} />
      )}
    </Modal>
  );
});

CurveModal.displayName = 'CurveModal';
